/**
 * Transforma alegerea din bannerul de cookie-uri in corpul pentru `POST /api/cookie-consents`.
 *
 * Pur, fara librarie si fara DOM, ca sa fie testabil pe mediul `node` al vitest. Backendul accepta
 * doar valorile de aici (`CookieConsentDTO`, regex pe fiecare camp), deci o categorie noua cere
 * schimbare in ambele parti.
 */

import type { CookieConsentCerere } from "@/api/generated/types.gen";

export type AcceptType = "all" | "custom" | "necessary";

export type ActiuneAcord = "ACCEPTA_TOT" | "RESPINGE_TOT" | "PERSONALIZAT";

/** Categoriile cunoscute, in ordinea in care le asteapta backendul. */
export const CATEGORII_COOKIE = ["necessary", "analytics"] as const;

const ACTIUNE: Record<AcceptType, ActiuneAcord> = {
    all: "ACCEPTA_TOT",
    necessary: "RESPINGE_TOT",
    custom: "PERSONALIZAT",
};

export function construiestePayloadAcord(alegere: {
    consentId: string;
    acceptType: AcceptType;
    acceptedCategories: readonly string[];
    revizie: number;
}): CookieConsentCerere {
    // `necessary` e readOnly in banner, deci e mereu acceptata; o punem explicit ca sa nu depindem
    // de ordinea in care o raporteaza libraria. Categoriile necunoscute nu pleaca: backendul le-ar
    // respinge cu 400 si s-ar pierde toata dovada.
    const acceptate = new Set(alegere.acceptedCategories);
    acceptate.add("necessary");
    const categorii = CATEGORII_COOKIE.filter((c) => acceptate.has(c)).join(",");

    return {
        consentId: alegere.consentId,
        categorii,
        actiune: ACTIUNE[alegere.acceptType],
        revizie: alegere.revizie,
    };
}
